import Vue from 'vue';
import { AssetsDocumentActions, AssetsDocumentStubActionable } from '@/services/assets-api/AssetsDocumentService';

export const setFileToAdd = (fileToAdd: AssetsDocumentStubActionable, file: File) => {
  Vue.set(fileToAdd, 'action', AssetsDocumentActions.ADD_DOCUMENT);
  Vue.set(fileToAdd, 'file', file);
  Vue.set(fileToAdd, 'file_id', null);
  Vue.set(fileToAdd, 'file_name', file.name);
  Vue.set(fileToAdd, 'file_size', file.size);
};

export const setFileToDelete = (fileToDelete: AssetsDocumentStubActionable) => {
  Vue.set(fileToDelete, 'action', AssetsDocumentActions.DELETE_DOCUMENT);
  Vue.set(fileToDelete, 'file_id_delete', fileToDelete.file_id);
  Vue.set(fileToDelete, 'file', null);
  Vue.set(fileToDelete, 'file_id', null);
  Vue.set(fileToDelete, 'file_name', '');
  Vue.set(fileToDelete, 'file_size', null);
};
